module.exports = __webpack_public_path__ + "media/MRI9B.00d09762.mp3";